import { history } from '@history';
import axios, {
  AxiosError,
  AxiosRequestConfig,
  InternalAxiosRequestConfig,
  AxiosResponse,
} from 'axios';
import cogoToast from 'cogo-toast';
import { updateLastActivityEV } from 'store/main/events';
import { accessDeniedlogoutUserFX } from 'store/user/effects';
import { prepareRequestConfigHeaders } from './hooks/prepareRequestConfigHeaders';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_ROUTE,
  headers: {
    Accept: 'application/json, text/plain, */*',
    'Content-type': 'application/json;charset=utf-8',
  },
  timeout: 120000,
});

export type ApiRequestConfig = AxiosRequestConfig & {
  suppressForbiddenNotification?: boolean;
};

api.interceptors.request.use(async (config: InternalAxiosRequestConfig) => {
  await prepareRequestConfigHeaders(config);

  return config;
});

api.interceptors.response.use(
  (response: AxiosResponse) => {
    if (!response.config.url?.includes('api/v1/auth/keep-alive-token')) {
      updateLastActivityEV();
    }

    return response;
  },
  (error: AxiosError) => {
    const requestConfig = error.config as ApiRequestConfig | undefined;

    if (error.response?.status === 400) {
      return Promise.reject(error.response);
    }

    if (error.response?.status === 401) {
      accessDeniedlogoutUserFX();
    }

    if (
      error.response?.status === 403 &&
      !requestConfig?.suppressForbiddenNotification &&
      !error.response?.config?.url?.includes('v2/submissions/') &&
      !error.response?.config?.url?.includes('/show_shared_payment/') &&
      !error.response?.config?.url?.includes('/applications')
    ) {
      if (
        ['help_desk_ldap', 'help_desk_dummy_ldap'].includes(
          localStorage.getItem('auth_provider') || ''
        )
      ) {
        const { hide } = cogoToast.warn('Help desk lietotājam nav atļauts veikt šādas darbības', {
          hideAfter: 0,
          onClick: () => {
            hide?.();
          },
        });
      } else {
        const errorData = error.response.data as { message?: string } | undefined;
        const { hide } = cogoToast.warn(`403. ${errorData?.message || error.response.statusText}`, {
          hideAfter: 0,
          onClick: () => {
            hide?.();
          },
        });
      }
    }

    if (
      error.response?.config.url === '/api-profile/api/v1/profile' &&
      error.response?.status === 500
    ) {
      history.push('/maintenance');
    }

    return Promise.reject(error.response);
  }
);

export default api;
